import {Tab} from '@pepsico-ds/ui';
export default Tab;
